module.exports = __webpack_public_path__ + "static/media/play.e3fcd01c.png";